import axios from 'axios';
import cryptoJs from './CryptoJsService';
import AuthService from './AuthService';

const basePath = process.env.VUE_APP_API_URL;
const tokenItemName = 'tokenData';
const credenciales = {
    "grant_type": process.env.VUE_APP_API_GRANT_TYPE,
    "client_id": process.env.VUE_APP_API_CLIENT_ID,
    "client_secret": process.env.VUE_APP_API_CLIENT_SECRET
};
const config = {
    headers: { 'Content-Type': 'application/json' }
};

export default class AuthApiService {
    bPath() {
        return basePath;
    }

    getTknNameStorage() {
        return tokenItemName;
    }

    async getAccessToken() {
        // si no hay el item en el storage no se ha hecho el auth con el api
        if (localStorage.getItem(tokenItemName) === null) {         
            //realizo autenticacion y lleno localstorage para regresarlo   
            return this.realizarAutenticacion();       
        }
        // ya se hizo el auth con el api pero hay que validar su expiracion 
        return this.getDataLocalStorage();
    }
    
    getDataLocalStorage() {
        const tokenData = this.decryptLocalStorage();
        if (tokenData != null) {
            const diferenciaMilisegundos = Date.now() - tokenData.time_get_token;
            const diferenciaSegundos = diferenciaMilisegundos / 1000;
            if (diferenciaSegundos >= tokenData.expires_in || !tokenData.user) {
                // ya expiro, se realiza de nuevo el auth con el api y se crea de nuevo el storage
                localStorage.removeItem(tokenItemName);
                return this.realizarAutenticacion();
            }
        }
        return tokenData;
    }

    encryptLocalStorage(tokenData) {
        localStorage.setItem( tokenItemName, cryptoJs.encrypt(JSON.stringify(tokenData)) );
    }

    decryptLocalStorage() {
        return JSON.parse( cryptoJs.decrypt(localStorage.getItem(tokenItemName)) );
    }

    destroyStorage() {
        localStorage.clear();
    }

    async realizarAutenticacion() {
        const response = await axios.post(basePath + 'oauth/token', credenciales, config);
        if (response.status === 200) {
            const tokenData = response.data;
            tokenData.time_get_token = Date.now();
            const aService = new AuthService();
            const oUser = aService.getUser();
            if (oUser) {
                const oHeaders = { headers: { 'Authorization': tokenData.token_type + ' ' + tokenData.access_token } };
                const r = await axios.get(basePath + 'api/usuario/por-correo/' + oUser.userName, oHeaders);
                tokenData.user = r.data.data;
                tokenData.menu = null;
                if (tokenData.user != null) {
                    const r2 = await axios.get(basePath + 'api/menu-usuario/' + tokenData.user.idPerfil, oHeaders);
                    tokenData.menu = r2.data.data;
                    // buscar info en banner para actualizar el ID anahuac
                    const respRua = await axios.get(basePath + 'api/usuario-rua/por-correo/' + oUser.userName, oHeaders);
                    const dataUserRUA = respRua.data.data;
                    if (typeof dataUserRUA.idAnahuac != 'undefined' && dataUserRUA.idAnahuac != null) {
                        const datosUsuario = { 'idAnahuac': dataUserRUA.idAnahuac };
                        if (typeof dataUserRUA.campus != 'undefined' && dataUserRUA.campus != null) {
                            datosUsuario.campus = dataUserRUA.campus;
                        }    
                        axios.put(basePath + 'api/usuario/' + tokenData.user.id + '/actualiza-campus-idanahuac', datosUsuario, oHeaders);
                    }
                }
            }
            this.encryptLocalStorage(tokenData);
            return this.decryptLocalStorage();
        }
        return null;
    }

    buscarUsuarioBanner() {
        this.isLoading = true;
        var user = this.$AuthService.getUser()
        const correo = user.userName;
        this.$AuthApiService.getAccessToken().then(r => 
          this.$axios.get(process.env.VUE_APP_API_URL + 'api/usuario-rua/por-correo/' + correo, {
            headers: { 'Authorization': r.token_type + ' ' + r.access_token }
          })
          .then(response => {
            const data = response.data.data;
            this.usuario = data;
            if (this.usuario.campus == null) {
              this.sinCampus = true;
              this.obtenerCampus();
            }
            if (typeof this.usuario.nombre == 'undefined') {
              const usuarioNombre = this.separarNombre(user.name);
              this.usuario.nombre = usuarioNombre.nombre;
              this.usuario.apellidoPaterno = usuarioNombre.apellidoPaterno;
              this.usuario.apellidoMaterno = usuarioNombre.apellidoMaterno;
            }
            this.isLoading = false;
          })
          .catch(error => {
            console.log(error.response);
          })
        );
      }
}
